import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './Productos.css';

const Productos = () => {
  const [productos, setProductos] = useState([]);
  const [cargando, setCargando] = useState(true);
  const [errorFetch, setErrorFetch] = useState(null); // <- NUEVO: Estado para capturar errores
  
  const [busqueda, setBusqueda] = useState('');
  const [filtroTamano, setFiltroTamano] = useState('');
  const [filtroMaduracion, setFiltroMaduracion] = useState('');
  const [mostrarFiltros, setMostrarFiltros] = useState(false);

  useEffect(() => {
    const obtenerProductos = async () => {
      try {
        // OJO ACÁ: Si tu backend está en AWS, esto debería ser http://56.124.35.153:3001/api/productos
        const respuesta = await fetch('https://api.pascolo.com.ar/api/web/catalogo');
        
        if (!respuesta.ok) {
           throw new Error(`Error del servidor: código ${respuesta.status}`);
        }

        const data = await respuesta.json();

        // Validamos que realmente sea un array antes de guardarlo
        if (Array.isArray(data)) {
          setProductos(data);
        } else {
          throw new Error("El backend no devolvió una lista válida de productos.");
        }
        
        setCargando(false);
      } catch (error) {
        console.error("Error detallado:", error);
        setErrorFetch(error.message); // Guardamos el error para mostrarlo en pantalla
        setCargando(false);
      }
    };

    obtenerProductos();
  }, []);

  const productosFiltrados = productos.filter((producto) => {
    return producto.nombre?.toLowerCase().includes(busqueda.toLowerCase());
  });

  if (cargando) return <div className="cargando">Cargando catálogo Páscolo...</div>;

  // NUEVO: Si hubo un error en la conexión, lo mostramos gigante
  if (errorFetch) return (
    <div style={{ textAlign: 'center', padding: '50px', color: '#d9534f' }}>
      <h2>Ocurrió un problema de conexión</h2>
      <p>{errorFetch}</p>
      <p>Revisá que el backend esté encendido y la ruta sea correcta.</p>
    </div>
  );

  return (
    <div className="catalogo-container">
      <button className="btn-toggle-filtros" onClick={() => setMostrarFiltros(!mostrarFiltros)}>
        {mostrarFiltros ? "Ocultar búsqueda" : "Buscar productos"}
      </button>

      <aside className={`catalogo-sidebar ${mostrarFiltros ? "activo" : ""}`}>
        <div className="filtro-grupo">
          <label>Buscar por nombre</label>
          <input 
            type="text" 
            placeholder="Ej: Gouda, Saborizado..." 
            value={busqueda}
            onChange={(e) => setBusqueda(e.target.value)}
          />
        </div>
        
        <button className="btn-limpiar" onClick={() => setBusqueda('')}>
          Limpiar búsqueda
        </button>
      </aside>

      <main className="catalogo-main">
        <h2 className="catalogo-titulo">Catálogo</h2>
        {productosFiltrados.length === 0 ? (
          <p className="no-resultados">No se encontraron productos en la base de datos.</p>
        ) : (
          <div className="productos-grilla">
            {productosFiltrados.map((producto) => (
              <div key={producto.id} className="producto-tarjeta-simple">
                
                <Link to={`/productos/${producto.id}`} className="tarjeta-imagen-link">
                  <img 
                    src={producto.imagen_url || '/placeholder-queso.jpg'} 
                    alt={producto.nombre} 
                    className="producto-imagen"
                    style={{ width: '100%', height: '200px', objectFit: 'cover', borderRadius: '8px 8px 0 0' }}
                  />
                </Link>

                <div className="tarjeta-info" style={{ padding: '15px' }}>
                  <Link to={`/productos/${producto.id}`} className="tarjeta-titulo" style={{ textDecoration: 'none', color: '#333' }}>
                    <h4 style={{ margin: '0 0 10px 0', fontSize: '18px' }}>{producto.nombre}</h4>
                  </Link>

                  <p className="precio-destacado" style={{ fontSize: '20px', fontWeight: 'bold', color: '#2d5a27', margin: '0 0 10px 0' }}>
                    $ {Number(producto.precio_base_kg).toLocaleString('es-AR')} <span style={{ fontSize: '14px', color: '#666', fontWeight: 'normal' }}>/ kg</span>
                  </p>
                  
                  <p className="stock-info" style={{ minHeight: '40px', fontSize: '13px', color: '#555', marginBottom: '15px' }}>
                    {producto.descripcion || 'Queso de elaboración artesanal. Ingresá para ver formatos y maduración disponible.'}
                  </p>
                  
                  <Link 
                    to={`/productos/${producto.id}`} 
                    className="btn-ver-detalle"
                    style={{ display: 'block', textAlign: 'center', backgroundColor: '#2d5a27', color: 'white', padding: '10px', borderRadius: '5px', textDecoration: 'none', fontWeight: 'bold' }}
                  >
                    Ver detalle
                  </Link>
                </div>
              </div>
            ))}
          </div>
        )}
      </main>
    </div>
  );
};

export default Productos;